import { PaymentMethodType, PaymentMethodPurpose } from '~/swagger/pay/Api';
import type { PaymentMethodDto } from '~/swagger/pay/Api';

export function formatPayPaymentMethodLabel(m: PaymentMethodDto): string {
  if (m.description?.trim()) {
    return m.description.trim();
  }

  const holder = m.holder?.trim();
  if (holder && m.last4) {
    return `${holder} ****${m.last4}`;
  }

  if (m.last4) {
    const type = m.brand?.trim() || m.cardType?.trim() || m.accountType?.trim();
    return type ? `${type} ****${m.last4}` : `****${m.last4}`;
  }

  const typeOnly = m.brand?.trim() || m.cardType?.trim() || m.accountType?.trim();
  if (typeOnly) {
    return typeOnly;
  }

  return m.id;
}

export function isCollectionsOnlyAccount(method: PaymentMethodDto): boolean {
  return (
    method.type === PaymentMethodType.Ach &&
    method.capabilities?.includes(PaymentMethodPurpose.Collect) === true &&
    !method.capabilities.includes(PaymentMethodPurpose.Payout)
  );
}
